import { Directive, HostBinding, input } from '@angular/core'

@Directive({
  selector: 'mat-card[libElevation], [libElevation]',
})
export class ElevationDirective {
  readonly elevation = input<number>(undefined, { alias: 'libElevation' })

  @HostBinding('class')
  get elevationClass() {
    const level = this.elevation()
    if (level) {
      return `app-elevation-${level}`
    }
    return ''
  }
}
